import { useCallback, useState } from "react";

import gql from "graphql-tag";
import { useMutation } from "react-apollo";

import { getValidationErrors } from "helpers/validation";

const useEnterpriseFormBlockService = () => {
  const [salesRequest] = useMutation(gql`
    mutation salesRequest(
      $firstName: String!,
      $lastName: String!,
      $email: String!,
      $companyName: String!,
      $companySize: String!,
      $jobTitle: String!,
    ) {
      salesRequest(
        firstName: $firstName,
        lastName: $lastName,
        email: $email,
        companyName: $companyName
        companySize: $companySize,
        jobTitle: $jobTitle,
      ) {
        mutationId
      }
    }
  `);

  const [isLoading, setIsLoading] = useState(false);
  const [isFormSuccessful, setIsFormSuccessful] = useState(false);
  const [inputs, setInputs] = useState({
    firstName: "",
    lastName: "",
    email: "",
    companyName: "",
    companySize: "",
    jobTitle: "",
  });
  const [errors, setErrors] = useState({
    general: [],
    email: [],
  });

  const onValueChange = useCallback((key: string, value: string) => {
    setInputs((prev) => ({ ...prev, [key]: value }));
  }, []);

  const onSubmit = useCallback(
    async (event: React.FormEvent) => {
      try {
        event.preventDefault();

        setIsLoading(true);
        setErrors({
          ...errors,
          general: [],
          email: [],
        });

        await salesRequest({
          variables: {
            firstName: inputs.firstName,
            lastName: inputs.lastName,
            email: inputs.email,
            companyName: inputs.companyName,
            companySize: inputs.companySize,
            jobTitle: inputs.jobTitle,
          },
        });

        setIsLoading(false);
        setIsFormSuccessful(true);
      } catch (error) {
        setIsLoading(false);
        setErrors({
          ...errors,
          ...getValidationErrors(error),
        });
      }
    },
    [errors, inputs, salesRequest],
  );

  return {
    isLoading,
    isFormSuccessful,
    inputs,
    errors,
    onSubmit,
    onValueChange,
  };
};

export default useEnterpriseFormBlockService;
